import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';

import { Messages } from '../../../gen-src/Localize';
import { WorkbookQuery, WorkbookQuery_workbooks, WorkbookQueryVariables } from '../../../gen-src/queries/WorkbookQuery';
import { WorkbookQueryGql } from '../../queries/WorkbookQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type WorkbookQueryWrapperProps = {
  readonly vizportalUrlId: string;
  readonly children: (result: WorkbookQuery_workbooks) => React.ReactNode;
};

export class WorkbookQueryWrapper extends React.Component<WorkbookQueryWrapperProps> {

  public render(): React.ReactNode {
    return (
      <Query<WorkbookQuery, WorkbookQueryVariables>
        query={WorkbookQueryGql}
        variables={{ workbookVizportalUrlId: this.props.vizportalUrlId }}
      >
        {result => renderQueryResult(result, {
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderWorkbookData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderWorkbookData),
          renderError: renderError,
        })}
      </Query>
    );
  }

  private readonly renderWorkbookData = (data: WorkbookQuery): React.ReactNode => {
    const workbook = data.workbooks ? data.workbooks[0] : null;
    if (workbook) {
      return this.props.children(workbook);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }

}
